import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL } from '@plone/volto/helpers';
import { useIntl } from 'react-intl';
import messages from '../../../../messages';

const resolveLink = (val) => {
  if (!val) return '';
  if (typeof val === 'string') return val;
  if (Array.isArray(val)) return resolveLink(val[0]);
  if (val['@id']) return flattenToAppURL(val['@id']);
  if (val.url) return val.url;
  return '';
};

const getImageURL = (image) => {
  if (!image) return null;
  const img = Array.isArray(image) ? image[0] : image;
  const id = img?.['@id'] || img?.url;
  if (!id) return null;
  return `${flattenToAppURL(id)}/@@images/image`;
};

const HighlightView = ({ data = {}, mode = 'view' }) => {
  const {
    title,
    description,
    buttonLabel,
    buttonLink,
    image,
    fixedHeight,
    background_color = 'purple',
    content_half_width,
    content_horizontal_alignment,
    content_vertical_alignment,
  } = data;

  const intl = useIntl();

  const imageURL = getImageURL(image);
  const href = resolveLink(buttonLink);

  const backgroundStyle = imageURL
    ? { backgroundImage: `url(${imageURL})` }
    : {};

  const hasButton = buttonLabel && href;

  let horizontalAlignment = content_horizontal_alignment;
  if (!['left', 'center', 'right'].includes(horizontalAlignment)) {
    horizontalAlignment = 'left';
  }

  let verticalAlignment = content_vertical_alignment;
  if (!['top', 'center', 'bottom'].includes(verticalAlignment)) {
    verticalAlignment = fixedHeight ? 'center' : 'bottom';
  }

  const isHalfWidth = Boolean(content_half_width);

  return (
    <div className="block fcmhHighlight">
      <div
        className={cx(
          'fcmh-highlight',
          `fcmh-highlight--bg-${background_color}`,
          `fcmh-highlight--x-${horizontalAlignment}`,
          `fcmh-highlight--y-${verticalAlignment}`,
          {
            'is-edit-mode': mode === 'edit',
            'no-image': !imageURL,
            'is-fixed': fixedHeight,
          },
        )}
        style={backgroundStyle}
      >
        <div className="fcmh-highlight__overlay" />

        <div
          className={cx('fcmh-highlight__inner', {
            'fcmh-highlight__inner--half': isHalfWidth,
          })}
        >
          {title && <h2 className="fcmh-highlight__title">{title}</h2>}

          {description && (
            <p className="fcmh-highlight__description">{description}</p>
          )}

          {hasButton && (
            <UniversalLink
              href={href}
              className="fcmh-highlight__button ui button"
            >
              {buttonLabel}
            </UniversalLink>
          )}

          {mode === 'edit' && !title && !description && !hasButton && (
            <div className="fcmh-highlight__placeholder">
              {intl.formatMessage(messages.fcmhHighlightNoContent)}
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

HighlightView.propTypes = {
  data: PropTypes.object,
  mode: PropTypes.oneOf(['view', 'edit']),
};

export default HighlightView;
